import React, { useEffect, useState } from "react";
import SearchIcon from "../../assets/icons/search.svg";
import Header from "../partials/Header2";
import Sidebar from "../partials/Sidebar";
import styles from "../Lockers/style.module.css";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { motion } from "framer-motion";
import HashLoader from "react-spinners/ClipLoader";
import { useParams } from "react-router-dom";
import Delete from "../../assets/icons/delete.svg"
import Transaction from "../../assets/icons/transaction.svg"
import Info from "../../assets/icons/infoo.svg"
import Images from "../modal/Images";

const UserList = () => {
  const url = process.env.REACT_APP_APP_BACK_URL;
  let { slug } = useParams();
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const isAuthenticated = useSelector((state) => state.user);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState("");

  const [qrTypes, setQrTypes] = useState([]);

  const [site, setsite] = useState(isAuthenticated?isAuthenticated.site:'');
  const [role, setrole] = useState(isAuthenticated?isAuthenticated.role:'');
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [credentials, setCredentials] = useState({ type: "all", name: "" });
  const handleInput = (e) => {
    // Use the callback function to ensure that the state is updated before calling fetchData
    setCredentials((prevCredentials) => {
      const updatedCredentials = {
        ...prevCredentials,
        [e.target.name]: e.target.value,
      };
      fetchData(updatedCredentials);
      return updatedCredentials;
    });
  };
  useEffect(() => {
    fetchData(credentials);
    // getTypes();
  }, [currentPage]);

  const getTypes = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      const response = await fetch(`${url}/api/type/qr/types`, {
        mode: "cors",
        method: "GET",
        headers: headers,
      });

      const json = await response.json();
      setQrTypes(json);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async (fetchCredentials) => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      setIsLoading(true);
      setIsDisplay(false);
      setIsNotFound(false);

      const response = await fetch(
        `${url}/api/auth/get/userlist/?page=${currentPage}&limit=${itemsPerPage}&name=${fetchCredentials.name}&type=${fetchCredentials.type}`,
        {
          mode: "cors",
          method: "GET",
          headers: headers,
        }
      );
      setIsLoading(false);
      console.log(response, "response dataa");
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      console.log(json, "json dataa");
      if (json.users.length > 0) {
        setData(json.users);
        setIsDisplay(true);
      } else {
        setIsNotFound(true);
      }
      setTotalPages(json.totalPages);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Access-Control-Allow-Origin", "*");
        headers.append("Access-Control-Allow-Credentials", "true");

        const response = await fetch(`${url}/api/sites/delete/locker/${id}`, {
          mode: "cors",
          method: "DELETE",
          headers: headers,
        });

        if (response.ok) {
          fetchData(credentials); // Refresh the records list after successful deletion
          Swal.fire("Deleted!", "Locker  deleted successfully!", "success");
        } else {
          Swal.fire(
            "Error",
            "An error occurred while deleting the record.",
            "error"
          );
        }
      }
    } catch (error) {
      console.log("Error deleting record:", error);
      Swal.fire(
        "Error",
        "An error occurred while deleting the record.",
        "error"
      );
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1); // react-paginate uses zero-based indexing
  };
  const openModal = (imageUrl) => {
    setSelectedImageUrl(imageUrl);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImageUrl("");
  };
  const formattedDate = (date) => {
    if (!date) {
      // If date is empty or null, use the current date
      date = new Date();
    }

    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const [isActive, setIsActive] = useState(false);

  // Function to toggle the active state
  const toggleActive = () => {
    setIsActive(!isActive);
  };

  // Define the CSS classes based on the isActive state
  const divClassName = isActive ? "sidebar active" : "sidebar";

  const handleResetBtn = () => {
    const updatedCredentials = {
      name: "",
      type: "all",
    };

    // Update state and then call fetchData
    setCredentials(updatedCredentials);
    setCurrentPage(1);

    // Call fetchData with the updated credentials
    fetchData(updatedCredentials);
  };
  function toggleFilterSection() {
    setIsFilterVisible(!isFilterVisible);
  }

  return (
    <div className={styles.heading}>
      <section className={styles.sidebar_wrap}>
        <div className="body-wrap">
          <div className="container-fluid px-0">
            <div className="d-flex">
              <Sidebar />
              <div className="p-3 w-100 main__content">
                <Header isActive={isActive} toggleActive={toggleActive} />
                <div className="general-dashboard">
                  <div className="container-fluid">
                    <div className="mb-3">
                      <div className="row">
                        <div className="col-lg-6 my-auto">
                          <div className="user-wrap">
                            <h3>Users</h3>
                            <p>List of all the users in the system</p>
                          </div>
                        </div>
                        <div className="col-lg-6 text-end">
                          <div className="filter-right-sec">
                            <div className="filter-wrap">
                              <div
                                className="filter-box"
                                onClick={toggleFilterSection}
                              >
                                <i className="fas fa-filter" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {isFilterVisible && (
                        <>
                          <motion.div
                            className={`row mt-5 filter-section`}
                            initial={{ opacity: 0 }} // Initial state (hidden)
                            animate={{ opacity: isFilterVisible ? 1 : 0 }} // Animate opacity based on isFilterVisible
                            transition={{ duration: 1.2, delay: 0.1 }}
                          >
                            <div className="col-12">
                              <div className="filter-right-sec filter-wrap-chat">
                                <div className="search-wrap">
                                  <input
                                    type="search"
                                    placeholder="search by username"
                                    name="name"
                                    value={credentials.name}
                                    onChange={handleInput}
                                  />
                                  <div className="search-box">
                                    <img src={SearchIcon} alt="" />
                                  </div>
                                </div>
                                <Link
                                  to=""
                                  onClick={handleResetBtn}
                                  className="btn btn-prim w-auto"
                                >
                                  RESET
                                </Link>
                              </div>
                            </div>
                          </motion.div>
                        </>
                      )}
                    </div>
                    {/* row */}
                    <div className="table-wrap">
                      <div className="row">
                        <div className="col-12">
                          <div className={styles.card_box}>
                            <div className={styles.tables_wrap}>
                              <div className="table-responsive">
                                <table className="table align-middle">
                                  <thead>
                                    <tr>
                                      <th style={{ fontWeight: "700", fontSize: "12px" }}>Name</th>
                                      <th style={{ fontWeight: "700", fontSize: "12px" }}>Email</th>
                                      <th style={{ fontWeight: "700", fontSize: "12px" }}>Played</th>
                                      <th style={{ fontWeight: "700", fontSize: "12px" }}>Wins</th>
                                      <th style={{ fontWeight: "700", fontSize: "12px" }}>Losts</th>
                                      <th style={{ fontWeight: "700", fontSize: "12px" }}>Amount</th>
                                      <th style={{ fontWeight: "700", fontSize: "12px" }}>Memes</th>
                                      <th ></th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {isLoading && (
                                      <>
                                        <tr>
                                          <td
                                            colSpan={4}
                                            className="text-end"
                                            style={{
                                              background: "transparent",
                                            }}
                                          >
                                            <HashLoader
                                              color={`#0b0d41`}
                                              loading={isLoading}
                                              size={40}
                                              aria-label="Loading Spinner"
                                              data-testid="loader"
                                            />
                                          </td>
                                        </tr>
                                      </>
                                    )}
                                    {isDisplay && data.length > 0
                                      ? data.map((item, i) => (
                                        <tr>
                                          <td>
                                            <div className="usr_det_tb">
                                              <span>{item.name}</span>
                                            </div>{" "}
                                          </td>

                                          <td className="text-lowercase">
                                            {item.email}
                                          </td>
                                          <td>{item.total_win || 0}</td>
                                          <td>{item.wins || 0}</td>
                                          <td>{item.losts || 0}</td>
                                          <td>
                                            {item.total_amount
                                              ? "$" + item.total_amount.toFixed(2)
                                              : 0}
                                          </td>
                                          <td>{item.total_memes || 0}</td>

                                          <td className="d-flex justify-content-end gap-2 ">

                                            <Link
                                              to={`/bank/details/${item._id}`}
                                            >

                                              <img src={Info} alt="info" />

                                            </Link>
                                            <Link
                                              to={`/game/details/${item._id}`}
                                            >

                                              <img src={Transaction} alt="transaction" />

                                            </Link>
                                            <Link

                                              onClick={() =>
                                                handleDelete(item._id)
                                              }
                                            >
                                              <img src={Delete} alt="delete" />
                                            </Link>
                                            {/* </div> */}
                                          </td>
                                          <td></td>
                                        </tr>
                                      ))
                                      : isNotFound && (
                                        <tr>
                                          <td
                                            colSpan={7}
                                            className="text-center"
                                          >
                                            <p className="text-center" style={{ color: "red" }}>
                                              No data found.
                                            </p>
                                          </td>
                                        </tr>
                                      )}
                                  </tbody>
                                </table>
                              </div>
                              <div className="table-num">
                                {data.length > 0 && (
                                  <ReactPaginate
                                    previousLabel={"<"}
                                    nextLabel={">"}
                                    breakLabel={"..."}
                                    pageCount={totalPages}
                                    forcePage={currentPage - 1} // react-paginate uses zero-based indexing
                                    onPageChange={handlePageChange}
                                    containerClassName={" dig-num"}
                                    pageClassName={"dig-num"}
                                    previousClassName={"num-btns"}
                                    nextClassName={"num-btns"}
                                    disabledClassName={"pagination-disabled"}
                                    activeClassName={"pagination-active"}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default UserList;
